import { EAdvancedFilterType } from 'shared/enums/EAdvancedFilterType';
import { FormattedTag } from 'shared/models/FormattedTag';

export const isIdUserTag = (tag: FormattedTag): boolean => {
  return tag.filterName === EAdvancedFilterType.idUser;
};
